import { render, staticRenderFns } from "./DetailTemplate.vue?vue&type=template&id=20e4db2c"
import script from "./DetailTemplate.vue?vue&type=script&lang=js"
export * from "./DetailTemplate.vue?vue&type=script&lang=js"
import style0 from "./DetailTemplate.vue?vue&type=style&index=0&id=20e4db2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports